var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('el-tooltip',{attrs:{"content":_vm.tooltip,"placement":"left","effect":"light"}},[_c('i',{staticClass:"el-icon-question"})]),_c('span',[_vm._v(" "+_vm._s(_vm.label))])]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }